import { render, staticRenderFns } from "./bugEcharts.vue?vue&type=template&id=427b8416&scoped=true&"
import script from "./bugEcharts.vue?vue&type=script&lang=js&"
export * from "./bugEcharts.vue?vue&type=script&lang=js&"
import style0 from "./bugEcharts.vue?vue&type=style&index=0&id=427b8416&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427b8416",
  null
  
)

export default component.exports